import React from 'react';
import styles from './styles.less';

/** 统计类型：文案 / 图片 / 视频 */
export const STAT_TYPES = ['text', 'image', 'video'];

export const TYPE_LABEL = {
  text: '文案',
  image: '图片',
  video: '视频',
};

/** 图表配色（与设计图保持一致） */
export const CHART_COLORS = {
  text: '#8fadc8',
  image: '#c6d6e2',
  video: '#7d9db3',
  error: '#d9a3a3',
};

/** 千分位 */
export const formatNumber = (value) =>
  Number(value || 0).toLocaleString('en-US');

/** 百分比 */
export const formatRate = (value, fixed = 1) =>
  value === undefined || value === null || value === ''
    ? '-'
    : `${Number(value).toFixed(fixed)}%`;

/** 账号类型筛选选项：全部 / 文案 / 图片 / 视频 */
export const STAT_TYPE_OPTIONS = [
  { label: '全部', value: 'all' },
  ...STAT_TYPES.map((t) => ({
    label: TYPE_LABEL[t],
    value: t,
  })),
];

/** 统计某个类型下的整体成功率：成功数合计 / 生成总次数合计 */
export const calcSuccessRate = (rows) => {
  const sum = (key) =>
    rows.reduce((pre, cur) => pre + Number(cur[key] || 0), 0);
  const total = sum('total');
  return total ? (sum('success') / total) * 100 : 0;
};

/** 生成一组统计列（列标题前可选带类型前缀，接口字段为扁平结构） */
const createFieldColumns = (prefix) => {
  const title = (field) => `${prefix}${field}`;
  return [
    {
      title: title('生成次数'),
      dataIndex: 'total',
      width: 150,
      align: 'center',
      render: (value) => formatNumber(value),
    },
    {
      title: title('成功数'),
      dataIndex: 'success',
      width: 138,
      align: 'center',
      render: (value) => (
        <span className={styles.successText}>
          <i className={styles.successDot} />
          {formatNumber(value)}
        </span>
      ),
    },
    {
      title: title('失败数'),
      dataIndex: 'error',
      width: 138,
      align: 'center',
      render: (value) => (
        <span className={styles.errorText}>{formatNumber(value)}</span>
      ),
    },
    {
      title: title('成功率'),
      dataIndex: 'successRate',
      width: 138,
      align: 'center',
      render: (value) => (
        <span className={styles.successText}>{formatRate(value)}</span>
      ),
    },
    {
      title: title('失败率'),
      dataIndex: 'errorRate',
      width: 138,
      align: 'center',
      render: (value) => (
        <span className={styles.errorText}>{formatRate(value)}</span>
      ),
    },
  ];
};

/** 生成某类型一组的统计列 */
const createTypeColumns = (type) => createFieldColumns(TYPE_LABEL[type]);

/** 账号级（汇总）概览表格列：按当前筛选的类型生成对应统计列 */
export const createAccountColumns = (type) => {
  // 全部：不带头类型前缀，直接显示 生成次数 / 成功数 ...
  const isAll = type === 'all';
  return [
    {
      title: '账号',
      dataIndex: 'empName',
      width: 170,
      fixed: 'left',
      render: (text) => (
        <span className={styles.accountName}>
          <i className={styles.accountDot} />
          {text || '-'}
        </span>
      ),
    },
    ...(isAll ? createFieldColumns('') : createTypeColumns(type || 'text')),
  ];
};
